import { useAppContext } from '../contexts/AppContext'
import HttpService from '../services/httpService'

/**
 * Get an instance of the HttpService class configured using the app context.
 */
export default function useHttpService() {
  const { config } = useAppContext()

  return new HttpService({
    baseUrl: config?.serviceBaseUrl,
    token: config?.serviceAuthToken,
  })
}
